module.exports = __webpack_public_path__ + "0025ae5855e7c3320b4d0ece17c3cc4f.jpg";